/**
 * A count on an icon button (unread notifications, open comments): `.count-badge`, over the top
 * right corner of a `position: relative` button. Nothing for zero; 99+ above that.
 */
export function CountBadge({ count, tone = 'accent' }: { count: number; tone?: 'accent' | 'danger' }) {
  if (count <= 0) return null;
  return <span className={tone === 'danger' ? 'count-badge danger' : 'count-badge'}>{count > 99 ? '99+' : count}</span>;
}
